<template>
<div></div>
</template>

<script>
// import mqtt from 'mqtt'
import * as mqtt from 'mqtt/dist/mqtt.min';
export default {
  name: 'mqtt',
  data() {
    return {
      // userId: this.$store.state.user.userId,
      connection: {
        protocol: process.env.VUE_APP_BASE_PROTOCOL,
        host: process.env.VUE_APP_BASE_HOST,
        // ws: 8083; wss: 8084
        port: process.env.VUE_APP_BASE_PORT,
        endpoint: '/mqtt',
        // for more options, please refer to https://github.com/mqttjs/MQTT.js#mqttclientstreambuilder-options
        clean: true,
        connectTimeout: 30 * 1000, // ms
        reconnectPeriod: 4000, // ms
        clientId: Math.random()
          .toString(16)
          .substring(2, 8) + this.$store.state.user.userId,
        // auth
        username: process.env.VUE_APP_BASE_NAME,
        password:process.env.VUE_APP_BASE_PASSWORD,
        keepalive: 50,
      },
      subscription: {
        topic: this.$store.state.user.topicPrefix + this.$store.state.user.userId,
        qos: 0,
      },
      // publish: {
      //   topic: '/eecm/cloud/pc/alarm/69',
      //   qos: 0,
      //   payload: '{ "msg": "Hello, I am browser." }',
      // },
      receiveNews: '',
      qosList: [0, 1, 2],
      client: {
        connected: false,
      },
      subscribeSuccess: false,
      connecting: false,
      retryTimes: 0,
    }
  },
  methods: {
    initData() {
      this.client = {
        connected: false,
      }
      this.retryTimes = 0
      this.connecting = false
      this.subscribeSuccess = false
    },
    handleOnReConnect() {
      this.retryTimes += 1
      if (this.retryTimes > 5) {
        try {
          this.client.end()
          this.initData()
          this.$message.error('Connection maxReconnectTimes limit, stop retry')
        } catch (error) {
          this.$message.error(error.toString())
        }
      }
    },
    // 连接
    createConnection() {
      console.log('走这了吗');
      try {
        this.connecting = true
        const {
          protocol,
          host,
          port,
          endpoint,
          ...options
        } = this.connection
        const connectUrl = `${protocol}://${host}:${port}${endpoint}`
        console.log('connectUrl', connectUrl);
        this.client = mqtt.connect(connectUrl, options)
        if (this.client.on) {
          this.client.on('connect', () => {
            this.connecting = false
            // this.doSubscribe()
            this.client.subscribe(this.subscription.topic)
            console.log('Connection succeeded!')
          })
          this.client.on('reconnect', this.handleOnReConnect)
          this.client.on('error', error => {
            console.log('Connection failed', error)
          })
          this.client.on('message', (topic, message) => {
            this.receiveNews = this.receiveNews.concat(message)
            this.$emit('onMessage', JSON.parse(message))
            console.log(`Received message ${message} from topic ${topic}`)
          })
        }
      } catch (error) {
        this.connecting = false
        console.log('mqtt.connect error', error)
      }
    },
    // subscribe topic
    // https://github.com/mqttjs/MQTT.js#mqttclientsubscribetopictopic-arraytopic-object-options-callback
    // doSubscribe() {
    //   const { topic, qos } = this.subscription
    //   this.client.subscribe(topic, { qos }, (error, res) => {
    //     if (error) {
    //       console.log('Subscribe to topics error', error)
    //       return
    //     }
    //     this.subscribeSuccess = true
    //     // this.doPublish()
    //     console.log('Subscribe to topics res', res)
    //   })
    // },
    // publish message
    // https://github.com/mqttjs/MQTT.js#mqttclientpublishtopic-message-options-callback
    // doPublish() {
    //   const { topic, qos, payload } = this.publish
    //   this.client.publish(topic, payload, { qos }, error => {
    //     if (error) {
    //       console.log('Publish error', error)
    //     }
    //   })
    // },
  },
  mounted() {
    console.log('process.env.VUE_APP_BASE_PROTOCOL',process.env.VUE_APP_BASE_PROTOCOL);
    console.log('process.env.VUE_APP_BASE_HOST',process.env.VUE_APP_BASE_HOST);
    console.log('process.env.VUE_APP_BASE_NAME',process.env.VUE_APP_BASE_NAME);
    console.log('process.env.VUE_APP_BASE_PASSWORD',process.env.VUE_APP_BASE_PASSWORD);
    console.log('process.env.VUE_APP_BASE_PORT',process.env.VUE_APP_BASE_PORT);
    console.log('this.subscription.topic',this.subscription.topic);
    console.log('clientId',this.connection.clientId);
    this.createConnection()
  },
  props: {
    // webscoketUrl: {
    //   required: true,
    //   type: String
    // }
  },
  beforeDestroy() {
    if (this.client.connected) {
      try {
        this.client.end(false, () => {
          this.initData()
          console.log('Successfully disconnected!')
        })
      } catch (error) {
        console.log('Disconnect failed', error.toString())
      }
    }
  }
}
</script>

<style scoped lang="less"></style>
